import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  SUPPORT: {
    path: `${baseRoutes.userBaseRoutes}/support`,
  },
};

export default accessRoute;
